import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from '../../../utils/toastHelper';
import Loader from '../../../components/Loader';
import { printView, updateBulkOrders } from '../services/ordersService';
import { formatToLocal, convertTo12HourFormat } from '../../../utils/dateUtils';
import {
  formatSpecification,
  trimDecimalZero,
} from '../../../utils/commonUtils';
import { handlePrintOrderInfo } from './printOrderInfo';

export default function OrdersTable({
  permissionKey,
  orders,
  loading,
  isAllSelected,
  handleSelectAllChange,
  selectedOrders,
  handleRowSelect,
  permissions,
  isOrdersCatering,
  orderStatuses,
  handleStatusChange,
  deliveryStatuses,
  openEditModal,
  openViewModal,
  handleReadStatusChange,
  pathName,
  colorMappings,
  fetchData,
  pagination,
}) {
  const { t } = useTranslation('Order');

  // const [downloadInfo, setDownloadInfo] = useState({});
  // const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

  // Toggle dropdown open/close
  // const toggleDropdown = (orderId) => {
  //   setOpenDropdown((prev) => (prev === orderId ? null : orderId));
  // };

  // Function to close the dropdown when an invoice type is selected
  // const handleSelectionAndClose = (orderId, type) => {
  //   handleTypeSelection(orderId, type);
  //   setOpenDropdown(null); // Close only when selecting an invoice type
  // };
  // const handleDownloadInfoChange = (e, orderId) => {
  //   setDownloadInfo((prev) => ({
  //     ...prev,
  //     id: orderId,
  //     company: e.target.value,
  //   }));
  // };
  // const handleTypeSelection = (orderId, type) => {
  //   if (downloadInfo.id !== orderId || !downloadInfo.company) {
  //     showWarningToast(t('PLEASESELECTCOMPANY'));
  //   }

  //   handleDownload(orderId, type);
  // };

  // const handleDownload = async (orderId, type) => {
  //   const queryData = {
  //     orderId,
  //     type,
  //     company: downloadInfo.company,
  //   };
  //   try {
  //     const printResponse = await printView(queryData, type + '.pdf');
  //     if (printResponse?.success) {
  //       // update status//
  //       await updateOrderStatus(orderId);
  //       // const matchedStatus = orderStatuses.find((orderStatus) =>
  //       //   ['處理中', 'processing'].includes(orderStatus.name.toLowerCase())
  //       // );

  //       // if (matchedStatus) {
  //       //   const response = await updateBulkOrders({
  //       //     type: 'orderStatus',
  //       //     orders: [orderId],
  //       //     action: matchedStatus.name,
  //       //     isPrint: true,
  //       //   });
  //       //   if (response.success) {
  //       //     showSuccessToast(response?.message || 'Success');
  //       //     fetchData(pagination.current_page, 1);
  //       //   }
  //       // }
  //     }
  //   } catch (error) {
  //     showErrorToast(error?.message);
  //   }
  // };
  const updateOrderStatus = async (orderId) => {
    // update status//

    const matchedStatus = orderStatuses.find((orderStatus) =>
      ['處理中', 'processing'].includes(orderStatus.name.toLowerCase())
    );

    if (matchedStatus) {
      const response = await updateBulkOrders({
        type: 'orderStatus',
        orders: [orderId],
        action: matchedStatus.name,
        isPrint: true,
      });
      if (response.success) {
        showSuccessToast(response?.message || 'Success');
        fetchData(pagination.current_page, 1);
      }
    }
  };
  // Handle clicks outside the dropdown
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     // Check if click is outside the dropdown trigger button AND dropdown menu
  //     if (
  //       dropdownRef.current &&
  //       !dropdownRef.current.contains(event.target) &&
  //       !event.target.closest('.print-drop-down')
  //     ) {
  //       setOpenDropdown(null);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, []);

  return (
    <div
      className={`table-outer ${orders.length >= 1 && orders.length <= 3 ? 'scroll' : ''} ${pathName === '/catering-orders' ? 'catering-outer-table' : ''}`}
    >
      <table className="table">
        <thead>
          <tr className="t-heading">
            <th className="t-checkbox">
              <label className="container">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAllChange}
                />
                <span className="checkmark"></span>
              </label>
            </th>
            <th className="receive">
              <h5>{t('RECEIVETIME')}</h5>
            </th>
            <th className="update">
              <h5>{t('UPDATETIME')}</h5>
            </th>
            <th className="order-no">
              <h5>{t('ORDERNO')}</h5>
            </th>
            <th className="delivery-date">
              <h5>{t('DELIVERYDATE')}</h5>
            </th>
            {pathName === '/orders-catering' && (
              <th className="po-number">
                <h5>{t('CUSTOMERGROUPNAME')}</h5>
              </th>
            )}
            <th className="customer-info">
              <h5>{t('CUSTOMERINFO')}</h5>
            </th>
            <th className="refrence-no">
              <h5>{t('REFERENCENUMBER')}</h5>
            </th>
            {pathName !== '/catering-orders' && (
              <th className="po-number">
                <h5>{t('PONUMBER')}</h5>
              </th>
            )}
            <th className="quantity">
              <h5>{t('QUANTITY')}</h5>
            </th>
            <th className="order-remark">
              <h5>{t('ORDERREMARK')}</h5>
            </th>
            <th className="order-status">
              <h5>{t('ORDERSTATUS')}</h5>
            </th>
            <th className="delivery-status">
              <h5>{t('DELIVERYSTATUS')}</h5>
            </th>
            <th className="action">
              <h5>{t('ACTION')}</h5>
            </th>
            {permissions?.[permissionKey]?.edit_permission === 1 && (
              <th className="read">
                <h5>{t('READ')}</h5>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr className="position-relative">
              <td colSpan="100%" className="loader-container mt-5">
                <Loader />
              </td>
            </tr>
          ) : (
            <>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="100%" className="text-center py-4">
                    {t('NORECORDAVAILABLE')}
                  </td>
                </tr>
              ) : (
                orders.map((order, index) => {
                  let showUpdateColor = order.show_updated_color;

                  // let showUpdateColor=false
                  // showUpdateColor= !!order.update_time;
                  // if (
                  //   [
                  //     '處理中',
                  //     'Processing',
                  //     '完成',
                  //     'completed',
                  //     '取消',
                  //     'cancelled',
                  //   ].includes(order.status.name)
                  // ) {
                  //   showUpdateColor=false;
                  // }
                  return (
                    <tr
                      key={index}
                      className={`${!!order.read_at ? 'without-bold-change' : 'for-bold-changes'} ${showUpdateColor ? colorMappings.updated.class : colorMappings?.[order.status?.name].class}`}
                    >
                      <td className="t-checkbox">
                        <label className="container">
                          <input
                            type="checkbox"
                            checked={selectedOrders.has(order.id)}
                            onChange={(e) => handleRowSelect(e, order.id)}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                      <td className="receive">
                        {formatToLocal(order.receive_time)}
                      </td>
                      <td className="update">
                        {formatToLocal(order.update_time)}
                      </td>
                      <td className="order-no">{order.number}</td>
                      <td className="delivery-date">{order.delivery_date}</td>
                      {pathName !== '/catering-orders' &&
                      pathName !== '/orders-catering' ? (
                        <td className="customer customer-info">
                          <span className="d-block">
                            {order.customer?.customer_group?.group ||
                              order.customer_group?.group ||
                              ''}
                          </span>

                          <span className="d-block">
                            {order.contact_name || ''}
                          </span>
                        </td>
                      ) : (
                        <>
                          {pathName === '/orders-catering' && (
                            <td className="customer customer-info">
                              {order.customer_group?.group || ''}
                            </td>
                          )}
                          <td className="customer customer-info">
                            <span className="d-block">
                              {order.customer?.name ||
                                order.customer_name ||
                                ''}
                            </span>

                            <span className="d-block">
                              {order.customer?.code || ''}
                            </span>
                          </td>
                        </>
                      )}
                      <td className="refrence-no">{order.reference_number}</td>
                      {pathName !== '/catering-orders' && (
                        <td className="po-number">{order.po_number}</td>
                      )}
                      {/* <td className="quantity">{order.quantity}</td> */}
                      <td className="quantity">
                        {Array.isArray(order.products)
                          ? order.products.reduce(
                              (sum, product) =>
                                sum + parseFloat(product?.quantity ?? 0),
                              0
                            )
                          : ''}
                      </td>
                      <td className="order-remark">{order.remark}</td>
                      <td className="order-status">
                        {pathName === '/catering-orders' ? (
                          <div className="dropdown">
                            <button className="btn " type="button" disabled>
                              {order.status?.name || ''}
                            </button>
                          </div>
                        ) : (
                          <div className="dropdown">
                            {permissions?.[permissionKey]?.edit_permission ===
                            1 ? (
                              <>
                                <button
                                  className="btn dropdown-toggle"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  {order.status?.name || ''}
                                </button>
                                <ul className="dropdown-menu">
                                  {orderStatuses.map((option, i) => (
                                    <li
                                      key={i}
                                      onClick={(e) =>
                                        handleStatusChange(
                                          order.id,
                                          option.id,
                                          'status'
                                        )
                                      }
                                    >
                                      <a
                                        className={`dropdown-item ${option.id == order.status?.id ? 'active' : ''}`}
                                      >
                                        {option.name}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </>
                            ) : (
                              order.status?.name || ''
                            )}
                          </div>
                        )}
                      </td>
                      <td className="delivery-status">
                        {pathName === '/catering-orders' ? (
                          <div className="dropdown">
                            <button className="btn" type="button" disabled>
                              {order.delivery_status?.name || ''}
                            </button>
                          </div>
                        ) : (
                          <div className="dropdown">
                            {permissions?.[permissionKey]?.edit_permission ===
                            1 ? (
                              <>
                                <button
                                  className="btn dropdown-toggle"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  {order.delivery_status?.name || ''}
                                </button>
                                <ul className="dropdown-menu">
                                  {deliveryStatuses.map((option, i) => (
                                    <li
                                      key={i}
                                      onClick={(e) =>
                                        handleStatusChange(
                                          order.id,
                                          option.id,
                                          'delivery_status'
                                        )
                                      }
                                    >
                                      <a
                                        className={`dropdown-item ${option.id == order.delivery_status?.id ? 'active' : ''}`}
                                      >
                                        {option.name}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </>
                            ) : (
                              order.delivery_status?.name || ''
                            )}
                          </div>
                        )}
                      </td>
                      <td className="action">
                        <div className="action-btn-change">
                          {permissions?.[permissionKey]?.edit_permission ===
                            1 && (
                            <button
                              onClick={() => {
                                openEditModal(order);
                              }}
                            >
                              <img
                                src={
                                  showUpdateColor
                                    ? colorMappings.updated.images?.edit
                                    : colorMappings?.[order.status?.name]
                                        ?.images?.edit
                                }
                                alt=""
                              />
                            </button>
                          )}
                          <button
                            onClick={() => {
                              openViewModal(order);
                            }}
                          >
                            <img
                              src={
                                showUpdateColor
                                  ? colorMappings.updated.images?.view
                                  : colorMappings?.[order.status?.name]?.images
                                      ?.view
                              }
                              alt=""
                            />
                          </button>
                          <div className="dropdown" ref={dropdownRef}>
                            {/* Trigger Button */}
                            {pathName !== '/catering-orders' && (
                              <button
                                className="btn btn-secondary dropdown-toggle"
                                // onClick={() => toggleDropdown(order.id)}
                                onClick={
                                  // pathName === '/orders-catering'
                                  //   ?
                                  () => {
                                    handlePrintOrderInfo(
                                      [order],
                                      isOrdersCatering
                                    );
                                    updateOrderStatus(order.id);
                                  }
                                  // : () => toggleDropdown(order.id)
                                }
                                // onClick={() =>
                                //   handlePrintOrderInfo([order], isOrdersCatering)
                                // }
                                // role="button"
                              >
                                <img
                                  src={
                                    showUpdateColor
                                      ? colorMappings.updated.images?.print
                                      : colorMappings?.[order.status?.name]
                                          ?.images?.print
                                  }
                                  alt="Print"
                                />
                              </button>
                            )}

                            {/* Dropdown Menu */}
                            {/* {openDropdown === order.id && (
                              <div className="dropdown-menu show print-drop-down">
                                <div className="dropdown-menu-list">
                                  <label className="d-block w-100 px-2 pt-2">
                                    {t('SELECTCOMPANY')}
                                  </label>
                                  <div className="radio">
                                    <p className="mb-0">
                                      <input
                                        type="radio"
                                        id={`test1-${index}`}
                                        name={`radio-group-${index}`}
                                        value="Fruttiboz"
                                        checked={
                                          downloadInfo.id === order.id &&
                                          downloadInfo.company === 'Fruttiboz'
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          handleDownloadInfoChange(e, order.id);
                                        }}
                                      />
                                      <label htmlFor={`test1-${index}`}>
                                        {t('FRUTTIBOZ')}
                                      </label>
                                    </p>
                                    <p className="mb-0">
                                      <input
                                        type="radio"
                                        id={`test2-${index}`}
                                        name={`radio-group-${index}`}
                                        value="Freco"
                                        checked={
                                          downloadInfo.id === order.id &&
                                          downloadInfo.company === 'Freco'
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          handleDownloadInfoChange(e, order.id);
                                        }}
                                      />
                                      <label htmlFor={`test2-${index}`}>
                                        {t('FRECO')}
                                      </label>
                                    </p>
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <a
                                      className={`dropdown-item ${!(downloadInfo.id === order.id && downloadInfo.company) ? 'disabled' : ''}`}
                                      onClick={(e) => {
                                        if (
                                          !(
                                            downloadInfo.id === order.id &&
                                            downloadInfo.company
                                          )
                                        ) {
                                          e.preventDefault();
                                          return;
                                        }
                                        handleSelectionAndClose(
                                          order.id,
                                          'INVOICE'
                                        );
                                      }}
                                    >
                                      {t('INVOICE')}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className={`dropdown-item ${!(downloadInfo.id === order.id && downloadInfo.company) ? 'disabled' : ''}`}
                                      onClick={(e) => {
                                        if (
                                          !(
                                            downloadInfo.id === order.id &&
                                            downloadInfo.company
                                          )
                                        ) {
                                          e.preventDefault();
                                          return;
                                        }
                                        handleSelectionAndClose(order.id, 'DN');
                                      }}
                                    >
                                      {t('DELIVERYNOTE')}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className={`dropdown-item ${!(downloadInfo.id === order.id && downloadInfo.company) ? 'disabled' : ''}`}
                                      onClick={(e) => {
                                        if (
                                          !(
                                            downloadInfo.id === order.id &&
                                            downloadInfo.company
                                          )
                                        ) {
                                          e.preventDefault();
                                          return;
                                        }
                                        handleSelectionAndClose(
                                          order.id,
                                          'RECEIPT'
                                        );
                                      }}
                                    >
                                      {t('RECEIPT')}
                                    </a>
                                  </li>
                                  {pathName !== '/orders-catering' && (
                                    <li>
                                      <a
                                        className={`dropdown-item`}
                                        onClick={() => {
                                          handlePrintOrderInfo(
                                            [order],
                                            isOrdersCatering
                                          );
                                          updateOrderStatus(order.id);
                                        }}
                                      >
                                        {t('PICKINGLISTS')}
                                      </a>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )} */}
                          </div>
                        </div>
                      </td>
                      {permissions?.[permissionKey]?.edit_permission === 1 && (
                        <td className="read">
                          <label className="container">
                            <input
                              type="checkbox"
                              checked={!!order.read_at}
                              onChange={(e) =>
                                e.preventDefault() ||
                                handleReadStatusChange(order.id)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </td>
                      )}
                    </tr>
                  );
                })
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
}
